// extracted by mini-css-extract-plugin
module.exports = {"wrap":"input-money_wrap__3sn82","list":"input-money_list__2nXn4"};